import React, { useEffect, useRef, useState } from 'react';
import ForceGraph2D from 'react-force-graph-2d';
import SpriteText from 'three-spritetext';

function Graph({ graphData }) {
    const containerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 800, height: 500 });

    useEffect(() => {
        const updateDimensions = () => {
            if (containerRef.current) {
                setDimensions({
                    width: containerRef.current.clientWidth,
                    height: containerRef.current.clientHeight
                });
            }
        };

        updateDimensions(); 
        window.addEventListener('resize', updateDimensions); 

        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);

    if (!graphData) {
        return <p>Loading graph...</p>; 
    }

    return (
        <div ref={containerRef} style={{ width: '100%', height: 'calc(100vh - 200px)', border: '1px solid #ccc', position: 'relative' }}>
            <ForceGraph2D
                width={dimensions.width}
                height={dimensions.height}
                graphData={graphData}
                nodeLabel="id"
                linkThreeObjectExtend={true}
                linkThreeObject={link => {
                    const sprite = new SpriteText(`${link.label}`);
                    sprite.color = 'lightgrey';
                    sprite.textHeight = 1.5;
                    return sprite;
                }}
                linkPositionUpdate={(sprite, { start, end }) => {
                    const middlePos = Object.assign(...['x', 'y'].map(c => ({
                        [c]: start[c] + (end[c] - start[c]) / 2
                    })));

                    Object.assign(sprite.position, middlePos);
                }}
            />
        </div>
    );
}

export default Graph;